import { Button, ConfigProvider, Dropdown, Menu, Modal, Space, theme } from 'antd';
import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';
import { MoreOutlined,CloseOutlined } from '@ant-design/icons';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;
import dayjs from 'dayjs';
import { getAdjustedDate, isExactMultipleOf24Hours } from '../CommonFunctions';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { adjustTimeByFiveHoursThirtyMinutes, calculateDateRangeFromDate } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
import { TransformVcbConsumptionToStackedBarChart } from '../chartdata.transformers';


export default function Chart3(props) {
  var series = props.series; 
  var style = props.style; 
  var title = props.title ? props.title : 'Sample Title'; 
  const [error, setError] = useState('');
  const correctDate = new Date(getAdjustedDate());
  const [data, setData] = useState();
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true); // Loading state

  // Default dates with time set to 6:30 AM
  const defaultToDate = dayjs(correctDate).hour(6).minute(30).second(0);
  const defaultFromDate = dayjs(correctDate).subtract(7, 'days').hour(6).minute(30).second(0);
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [open, setOpen] = useState(false);


  useEffect(() => {
    getTitleStyle();
  }, []);

  const getTitleStyle = () => {
    if (window.innerWidth < 600) {
      return {
        fontSize: 12,
        lineHeight: 15,
      };
    } else {
      return {
        fontSize: 18,
        lineHeight: 22,
      };
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dateStrings) {
      const start = new Date(dateStrings[0]);
      const end = new Date(dateStrings[1]);
      const DifferenceInHours = isExactMultipleOf24Hours(start, end);

      if (!DifferenceInHours) {
        setError(true);
      } else {
        setError(false);
        setToDate(end);
        setFromDate(start);
        setLoading(true);
        setRefetch(!refetch);
      }
    } else {
      console.log('Clear'); 
    }
  };

  const rangePresets = [
    {
      label: 'Last 7 Days',
      value: [dayjs().subtract(7, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
    },
    {
      label: 'Last 14 Days',
      value: [dayjs().subtract(14, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
    },
    {
      label: 'Last 30 Days',
      value: [dayjs().subtract(30, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
    },
    {
      label: 'Last 90 Days',
      value: [dayjs().subtract(90, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
    },
  ];

  const items = [
    {
      label: (
        <p className="" onClick={() => setOpen(!open)}>
          TV
        </p>
      ),
      key: "0",
    },
    {
      label: <p> Other Option</p>,
      key: "1",
    },
    // {
    //   type: 'divider',
    // },
  ];


  const getReposnse = async () => {
    setLoading(true); // Start loading
    const currentDate = new Date(); 
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 15);
    const inputData = {
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),  
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    }; 
    try {      
      const res = await makeRequest({
        type: APIConstants.GET, 
        url: `${APIConstants.LUCAS_TOOL_ROOM}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
      });
      function filterDataByGroupID(data, groupId) {
        return data.filter((item) => item.groupID === groupId);
      }
      console.log(res)
      if (res && res.length > 0) {
        const data = filterDataByGroupID(res,11)
        console.log(data)
        setData(TransformVcbConsumptionToStackedBarChart(data));
        console.log(TransformVcbConsumptionToStackedBarChart(res));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }    
  };

  useEffect(() => {
    getReposnse();
  }, [refetch]);

  var dataToShow = data && data.series ? data.series : series;
  var categories = data && data.categories ? data.categories : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const theme = props.theme;

  const colors = ["#ab0207","#013220", "#4B0101", "#001F3F", "#B8860B", "#8B4513"];


  return (
    <div className='lg:mt-0 sm:mt-10  w-full xl:w-[100%] shadow-allsides flex flex-col justify-center items-center relative'>
      <div className='border-b w-full  ' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className={`${theme === 'dark' ? "text-neutral-100" : 'text-neutral-600'}  md:text-2xl px-3 font-bold `} style={{ margin: 0 }}>{title}</h2>
        <Dropdown
                    menu={{
                    items,
                    }}
                    trigger={['click']}
                    arrow>
                    <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        <MoreOutlined className={`${theme === 'dark' ? "text-neutral-100" : 'text-neutral-600'} p-3 font-extrabold`} />
                    </Space>
                    </a>
                </Dropdown>
      </div>

      {loading ? (
        <div className="flex justify-center items-center w-full h-[200px]">
          <p className="text-white">Loading...</p>
        </div>
      ) : (
        <>
        <ReactECharts className={`${theme === 'dark' ? "bg-slate-950" : 'bg-slate-100'} lg:mt-0   h-[200px] sm:mt-10  w-full xl:w-[100%] m-auto mb-0  `}
          option={{
            toolbox: {
              show: true,
              feature: {
              //   dataZoom: {
              //     yAxisIndex: 'none'
              //   },
              //   dataView: { readOnly: false },
                magicType: { type: ['line', 'bar'] },
              //   restore: {},
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: categories,
              axisLabel: {
                interval: 'auto',
                rotate: 45,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0, 10) + '...' : value;
                }
              }
            },
            yAxis: {
              type: 'value',
              splitLine: {
                show: false, 
              },
            },
            legend: {
              // orient: 'vertical',
              right: '2px',
              left: 'center',
              textStyle: {
                color: 'gray',
              }, 
            },
            series: dataToShow?.map((seriesItem, index) => ({
              ...seriesItem,
              itemStyle: {
                color: colors[index % colors.length], // Cycle through colors
              },
              label: {
                show: true,
                position: "inside",
                color: theme==='dark'? "#fff":'#fff',
                fontSize: 12,
                rotate: 90
              },
            })),
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            }
          }}
          themes={props.theme}
        />
                <Modal
            title={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${theme === "dark" ? "white" : "black"} px-4 py-2`}
              >
                TV mode
              </div>
            }
            centered
            open={open}
            footer={null}
            onCancel={() => setOpen(false)}
            width="1350"
            className="bg-red-700"
            style={{
              padding: 0,
              top: 0,
              backgroundColor: theme === "dark" ? "#1e293b" : "#ffffff",
              color: theme === "dark" ? "#f0f0f0" : "#000000",
            }}
            closeIcon={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${
                  theme === "dark" ? "white" : "black"
                } p-0 mt-0 rounded-full`}
              >
                <CloseOutlined />
              </div>
            }
          >
            <div
              className={`${
                theme === "dark" ? "bg-slate-950" : "bg-slate-100"
              }`}
            >
             <ReactECharts className={`${theme === 'dark' ? "bg-slate-950" : 'bg-slate-100'} lg:mt-0   h-[200px] sm:mt-10  w-full xl:w-[100%] m-auto mb-0  `}
          option={{
            toolbox: {
              show: true,
              feature: {
              //   dataZoom: {
              //     yAxisIndex: 'none'
              //   },
              //   dataView: { readOnly: false },
                magicType: { type: ['line', 'bar'] },
              //   restore: {},
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: categories,
              axisLabel: {
                interval: 'auto',
                rotate: 45,
                formatter: function (value) {
                  return value.length > 10 ? value.substring(0, 10) + '...' : value;
                }
              }
            },
            yAxis: {
              type: 'value',
              splitLine: {
                show: false, // This hides the horizontal grid lines
              },
            },
            legend: {
              // orient: 'vertical',
              right: '2px',
              left: 'center',
              textStyle: {
                color: 'gray',
              },
            },
            series: dataToShow,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            }
          }}
          style={{ height: "900px", width: "1300px" }} 
          themes={props.theme}
        />
            </div>
          </Modal>
        </>
      )}
      <div className="flex justify-center items-center w-full pt-[0px]">
        <p className='bg-transparent w-fit p-2 md:mb-2 text-white'>
          <RangePicker
            presets={[
              {
                label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                value: () => [dayjs(), dayjs().endOf('day')],
              },
              ...rangePresets,
            ]}
            showTime
            format="YYYY/MM/DD HH:mm:ss"
            defaultValue={[defaultFromDate, defaultToDate]}
            className={`customRangePicker ${error ? "errorInDate" : ""} ${theme === 'dark' ? 'customRangePicker-dark' : 'customRangePicker-light'} `}
            onChange={onRangeChange}
            disabledDate={current => {
              return current && current > dayjs().endOf('day');
            }}
          />
          {
            error && <p className='text-white font-bold border-b-2 border-red-500'>
              The selected time range must be at least 24 hours and a multiple of 24 hours.
            </p>
          }
        </p>
      </div>
    </div>
  )
}
